import { ExpertRequestCloseReasonCode } from '@/__generated__/graphql';

/**
 * Display labels for the 9 user-selectable close reasons (ENG-5290 T2). Single
 * source for the close modal picker. `unknown_legacy` has no label — legacy rows
 * carry preserved free text instead.
 */
export const CLOSE_REASON_LABELS: Partial<Record<ExpertRequestCloseReasonCode, string>> = {
  [ExpertRequestCloseReasonCode.Filled]: 'Filled',
  [ExpertRequestCloseReasonCode.ExpertsSatisfied]: 'Satisfied with the experts',
  [ExpertRequestCloseReasonCode.FoundElsewhere]: 'Found expert(s) elsewhere',
  [ExpertRequestCloseReasonCode.ExpertsNotFound]: 'Couldn’t find suitable experts',
  [ExpertRequestCloseReasonCode.Budget]: 'Budget',
  [ExpertRequestCloseReasonCode.ProjectCancelled]: 'Project cancelled',
  [ExpertRequestCloseReasonCode.NoLongerNeeded]: 'No longer needed',
  [ExpertRequestCloseReasonCode.Duplicate]: 'Duplicate request',
  [ExpertRequestCloseReasonCode.Other]: 'Other',
};

/** Ordered options for the close-reason picker. */
export const CLOSE_REASON_OPTIONS = [
  ExpertRequestCloseReasonCode.Filled,
  ExpertRequestCloseReasonCode.ExpertsSatisfied,
  ExpertRequestCloseReasonCode.FoundElsewhere,
  ExpertRequestCloseReasonCode.ExpertsNotFound,
  ExpertRequestCloseReasonCode.Budget,
  ExpertRequestCloseReasonCode.ProjectCancelled,
  ExpertRequestCloseReasonCode.NoLongerNeeded,
  ExpertRequestCloseReasonCode.Duplicate,
  ExpertRequestCloseReasonCode.Other,
] as const;
